import React from 'react';
import { Layout } from 'antd';
import type { BasicProps } from 'antd/es/layout/layout';
import type { ThemeConfig } from 'antd';
import classnames from 'classnames';
import { ThemeProvider } from '../../theme/provider';
import { defaultHeaderTheme } from '../../theme';
import cn from './styles.module.scss';

export interface HeaderProps extends BasicProps {
  theme?: ThemeConfig;
  children?: React.ReactNode;
  customTokens?: {
    selectedMenuItemBorderColor?: string;
  }
}

export const Header = ({ className, children, customTokens, theme = defaultHeaderTheme, ...rest }: HeaderProps) => {
  return (
    <ThemeProvider theme={theme} customTokens={customTokens}>
      <Layout>
        <Layout.Header className={classnames(cn.header, className)} {...rest}>
          {children}
        </Layout.Header>
      </Layout>
    </ThemeProvider>
  );
};
